// removed by extract-text-webpack-plugin
module.exports = {"message":"rvb1rSjnEwBo-aG9BAhV3","message__container":"_37oj5j740gvZPT8NJDEo1P","message__text":"_3irxYFt37ZULi56gzkNm4H","message__button":"hLtYYtTxy_NS9Cc4HIdsh"};